<template>
  <el-row>
    <el-col :span="24">
      <el-card shadow="none">
        <div class="bed-main">
          <div class="bed-bg-main hidden-xs-only mr-20">
            <p class="bed-text">归寝设置</p>
          </div>
          <el-form :model="bedForm"
                   ref="bedForm"
                   class="bed-form">
            <el-form-item label="是否启用:"
                          prop="enabled">
              <el-switch v-model="bedForm.enabled"
                         active-color="#13ce66"
                         inactive-color="#ff4949">
              </el-switch>
            </el-form-item>
            <el-form-item label="归寝开始时间:"
                          prop="tw_open">
              <el-time-picker v-model="bedForm.tw_open"
                              format="HH:mm"
                              value-format="HH:mm"
                              placeholder="开始时间">
              </el-time-picker>
              <!-- <el-time-select v-model="bedForm.tw_open"
                              :picker-options="startProps"
                              placeholder="选择时间">
              </el-time-select> -->
            </el-form-item>
            <el-form-item label="归寝结束时间"
                          prop="tw_close">
              <el-time-picker v-model="bedForm.tw_close"
                              format="HH:mm"
                              value-format="HH:mm"
                              placeholder="结束时间">
              </el-time-picker>
              <!-- <el-time-select v-model="bedForm.tw_close"
                              :picker-options="{
                                    start: '18:00',
                                    step: '00:05',
                                    end: '23:55',
                                    minTime: bedForm.tw_open
                                  }"
                              placeholder="选择时间">
              </el-time-select> -->
            </el-form-item>
            <el-form-item>
              <el-button v-has="'/time_window/edit'"
                         type="primary"
                         @click="handleConfirm('bedForm')">确 定</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
export default {
  data() {
    return {
      bedForm: {
        enabled: true,
        tw_open: '',
        tw_close: ''
      },
      startProps: {
        start: '18:00',
        step: '00:10',
        end: '23:55'
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取数据
    getList() {
      fetch.getBedTimeInfo({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.bedForm = data
            this.bedForm.enabled = data.enabled === '1' ? true : false
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let datas = JSON.parse(JSON.stringify(this.bedForm))
          datas.enabled = datas.enabled ? '1' : '0'
          fetch.editBedTime({ ...datas }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.$message.success('操作成功')
                this.getList()
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.bed-main {
  display: flex;
  .bed-bg-main {
    width: 150px;
    height: 228px;
    line-height: 228px;
    background: url('../../../assets/img/clock.png') no-repeat 30px 80px, #fff;
    background-size: 80px auto;
    border-right: 1px solid #eaeefb;
    .bed-text {
      line-height: 60px;
      text-align: center;
      font-weight: 900;
      margin-left: -10px;
      font-size: 16px;
      color: #909399;
    }
  }
  .bed-form {
    flex: 1;
  }
}
</style>
